<template>
  <div class="survey">
    <span class="md-display-1"></span>
    <md-content class="md-elevation-4 md-alignment-center-center card-meoempresas">
      <div class="middle-card">
        <md-icon class="md-size-5x">error_outline</md-icon>
      </div>
      <span class="md-title">Link Expirado</span>
    </md-content>
  </div>
</template>

<script>
export default {
  name: 'survey-complete'
}
</script>

<style lang="scss" scoped>
.survey {
  margin: 10px;
}
.card-meoempresas {
  margin: auto auto;
  max-width: 1000px;
  min-height: 45vh;
}
.middle-card {
  padding-top: 10vh;
}
</style>
